import { Injectable } from '@angular/core';
import { LocalStorageKeys, LocalStorageService } from '@app/services/local-storage.service';
import { AppThemeMessages, GlobalEventService } from '@app/services/global-event.service';

export enum ThemeColor {
  Light = 'Light',
  Dark = 'Dark',
}

@Injectable({
  providedIn: 'root',
})
export class ThemeColorService {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly globalEventService: GlobalEventService,
  ) {}

  public themeColor: ThemeColor;
  public isCheckedThemeColor: boolean;
  readonly localStorageKeys = LocalStorageKeys;
  readonly strings = tiStrings.app.pages.main.components.userProfileDetails.theme;

  setThemeColor() {
    this.themeColor = ThemeColor[this.localStorageService.getItem(this.localStorageKeys.ti_theme_colors)];
    if (this.themeColor === ThemeColor.Dark) {
      this.isCheckedThemeColor = true;
      document.body.setAttribute('mode', `${ThemeColor[this.themeColor]}`);
      return;
    }
    this.isCheckedThemeColor = false;
    this.localStorageService.setItem(this.localStorageKeys.ti_theme_colors, `${ThemeColor[ThemeColor.Light]}`);
    document.body.setAttribute('mode', `${ThemeColor[ThemeColor.Light]}`);

    this.globalEventService.broadcast(AppThemeMessages.themeChanged, this.themeColor);
  }

  getThemeColor() {
    return this.themeColor;
  }

  switchThemeColor() {
    this.isCheckedThemeColor = !this.isCheckedThemeColor;
    this.themeColor = this.isCheckedThemeColor ? ThemeColor.Dark : ThemeColor.Light;
    this.localStorageService.setItem(this.localStorageKeys.ti_theme_colors, `${ThemeColor[this.themeColor]}`);
    document.body.setAttribute('mode', `${ThemeColor[this.themeColor]}`);

    this.globalEventService.broadcast(AppThemeMessages.themeChanged, this.themeColor);

    return this.themeColor;
  }

  getColorText() {
    switch (this.themeColor) {
      case ThemeColor.Light:
        return this.strings.light;
      case ThemeColor.Dark:
        return this.strings.dark;
    }
  }
}
